import React from 'react'
import AboutUsSection from './AboutUsSection'
import LogoSection from './LogoSection'
import OnlineTherapySection from './OnlineTherapySection'
import ReserveAnHourSection from './ReserveAnHourSection'

import DesktopTerapiLogo from 'images/landing-v2/desktop_new_logo.svg';
import DesktopMindwellLogo from 'images/mindwell-logo/mindwell-logo-new.svg';

import desktopLogo from 'images/landing-v2/desktop_new_logo.svg'

const Footer = ({b2b}) => {

    const domain = document.body.dataset.domain

    return (
        <div className='footer-container'>
            <div className="footer-sections-container">
                <LogoSection 
                    desktopLogo={domain=="mindwell" ? DesktopMindwellLogo : DesktopTerapiLogo} 
                    b2b={b2b}
                    logoClass={domain=="mindwell" ? "mindwellLogo" : "terapiLogo"}
                    contactEmail={domain=="mindwell" ? "hello@mindwell.ai" : "contacto@terapi-app.com"}
                />
                {domain != "mindwell" && <AboutUsSection/>}
                {domain != "mindwell" && <OnlineTherapySection/>}
                {domain != "mindwell" && <ReserveAnHourSection/>}
            </div>
            <p className='company-text'>© 2023 {domain=="mindwell" ? "Mindwell.ai" : "Terapi"}</p>
        </div>
    )
}

export default Footer
